import React from 'react';
import PropTypes from 'prop-types';
import { Hidden } from '@mui/material';
import Link from '@atoms/Link';
import Typography from '@atoms/Typography';
import { LinkItem } from './style';

const NavItem = ({ title, route, params, subTitle }) => (
  <>
    <LinkItem>
      <Link href={route} params={params}>
        <Typography variant="overline">{title}</Typography>
        <Hidden xsDown>
          <Typography variant="body2">{subTitle}</Typography>
        </Hidden>
      </Link>
    </LinkItem>
  </>
);

NavItem.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  route: PropTypes.string.isRequired,
  params: PropTypes.object
};

NavItem.defaultProps = {
  subTitle: undefined,
  params: {}
}

export default NavItem;
